import { useEffect, useState, useCallback } from "react";

export type ThemeName = "sand" | "slate" | "sage";

const STORAGE_KEY = "tirevault.theme";

export function applyTheme(theme: ThemeName) {
  const root = document.documentElement;
  if (theme === "sand") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", theme);
  }
}

export function getStoredTheme(): ThemeName {
  if (typeof window === "undefined") return "sand";
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === "slate" || v === "sage" ? v : "sand";
}

export function useTheme() {
  const [theme, setThemeState] = useState<ThemeName>(() => getStoredTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((t: ThemeName) => {
    window.localStorage.setItem(STORAGE_KEY, t);
    setThemeState(t);
  }, []);

  return { theme, setTheme };
}
